import { axiosInstance } from '../../utils/fetcher';
import { API } from '../../api';

const CancelToken = axiosInstance.CancelToken;

export const getMessageCenterFoldersEffect = () => {
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/GetMessageFolder`,
    method: 'get',
  });
};

export const getMessageCenterMessageListEffect = (params) => {
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/GetMessageList`,
    method: 'get',
    params,
  });
};

export const getMessageCenterMessageDetailsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/GetMessageDetail`,
    method: 'get',
    params,
  });
};

export const deleteMessageEffect = (data) => {
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/DeleteMessage`,
    method: 'post',
    data,
  });
};

export const setMessageAsReadEffect = (params) => {
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/MessageRead`,
    method: 'get',
    params,
  });
};

let getComposeEmailsCancelToken = () => {};
export const getComposeEmailsEffect = (params) => {
  getComposeEmailsCancelToken();
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/GetComposeUserList`,
    method: 'get',
    params,
    cancelToken: new CancelToken(function executor(c) {
      getComposeEmailsCancelToken = c;
    }),
  });
};

export const sendMessageEffect = (data) => {
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/SendNewMail`,
    method: 'post',
    data,
  });
};

export const replyMessageEffect = (data) => {
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/SendMailForReply`,
    method: 'post',
    data,
  });
};

export const forwardMessageEffect = (data) => {
  return axiosInstance.request({
    url: `${API.MESSAGE_CENTER}/SendMailForForword`,
    method: 'post',
    data,
  });
};
